export default __webpack_public_path__ + "static/media/qr-not-active.78c891f3.png";